"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcTimePicker = require("rc-time-picker");

var _rcTimePicker2 = _interopRequireDefault(_rcTimePicker);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../functions");

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

require("rc-time-picker/assets/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TIME_FORMAT = "HH:mm";

var TimePicker = function (_Component) {
    _inherits(TimePicker, _Component);

    function TimePicker(props) {
        _classCallCheck(this, TimePicker);

        var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

        _this.state = {
            selectedTime: (0, _moment2.default)()
        };
        return _this;
    }

    _createClass(TimePicker, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value) {
                this.setState({
                    selectedTime: _moment2.default.isMoment(nextProps.value) ? nextProps.value : (0, _moment2.default)(nextProps.value, DATE_FORMAT)
                });
            }
        }
    }, {
        key: "handleChange",
        value: function handleChange(time) {
            this.setState({
                selectedTime: time
            });
            return this.props.onChange({
                name: this.props.name,
                value: time.format(TIME_FORMAT)
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                label = _props.label,
                name = _props.name,
                value = _props.value,
                onChange = _props.onChange,
                error = _props.error,
                rest = _objectWithoutProperties(_props, ["label", "name", "value", "onChange", "error"]);

            return _react2.default.createElement(
                "div",
                null,
                label && _react2.default.createElement(
                    _label2.default,
                    _extends({ name: name, label: label }, this.props),
                    label
                ),
                this.props.easyRead && _react2.default.createElement(
                    "b",
                    null,
                    this.props.easyRead
                ),
                _react2.default.createElement(_rcTimePicker2.default, _extends({
                    name: this.props.name,
                    defaultValue: this.state.selectedTime,
                    value: this.state.selectedTime,
                    onChange: this.handleChange.bind(this)
                }, rest)),
                _react2.default.createElement(_inputError2.default, { error: error })
            );
        }
    }]);

    return TimePicker;
}(_react.Component);

TimePicker.displayName = "TimePicker";

TimePicker.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.any,
    label: _propTypes2.default.string,
    showSecond: _propTypes2.default.bool,
    use12Hours: _propTypes2.default.bool,
    error: _propTypes2.default.string
};

TimePicker.defaultProps = {
    showSecond: false,
    error: ""
};

exports.default = TimePicker;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/timePicker.js
// module id = 1009
// module chunks = 95715928098905 168707334958949